import CompartilhamentoService from "@/services/CompartilhamentoService";

export const compartilhamento = {
  namespaced: true,
  actions: {
    enviarEmail({ commit }, payload) {
      return CompartilhamentoService.EnviarEmail(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    whatsapp({ commit }, payload) {
      return CompartilhamentoService.Whatsapp(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
};
